import React, { useEffect } from 'react';
import Header from '../newHome/components/Header';
import Footer from '../newHome/components/Footer';
import './Pages.css';

function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-wrapper">
      <Header />
      <div className="page-container">
        <h1>Privacy Policy</h1>

        <p>Last updated: December 05, 2025</p>

        <section className="policy-section">

          <p>This Privacy Policy explains how Tython Labs Inc. (the "Company") collects, uses, discloses, and safeguards your information when you use our website, available at NewTherapy.ai, and various online products and services, which include our AI Therapist service (collectively, the "Services"). We respect your privacy and are committed to keeping secure any information we collect from you or about you. By using the Services, you agree to this policy.</p>
        </section>

        <section className="policy-section">
          <h2>1. Information we collect</h2>
          <p>We collect the following types of information:</p>
          <ul>
            <li><strong>Personal Information:</strong> If you create an account with us, we collect personal information that identifies you personally, such as your name, email address, and any other details you provide.</li>
            <li><strong>Service Data</strong> When you use the Services, we collect information such as the content of your interactions with the Service, conversations with the AI therapist chatbot, including text, voice recordings and/or transcriptions, images, and other media.</li>
            <li><strong>Technical and Usage Data</strong> We collect (i) information that your browser or device automatically sends when you use the Services, including IP address, browser type and settings, date and time, and other information, (ii) information about how you engage with the Services, such as date and time of access, type of computer or device, operating system and device identifiers, log data and location information, and (iii) we use cookies and similar tracking technologies to track the activity on our Services and hold certain information.</li>
            <li><strong>Information We Receive from Other Sources:</strong> We receive information from our trusted partners, such as security partners, to protect against fraud, abuse, and other security threats to the Services, and from marketing vendors who provide us with information about potential customers of our business services.</li>
            <li><strong>Other Information You Provide:</strong>Other information that you may provide to us, such as when you participate in our events or surveys.
              We may de-identify and/or aggregate certain of your information, like approximate location information, information about the device you use to access the Service, information about conversational trends, or other analyses we create. De-identified and/or aggregated information is not personal information and we may use and share this information as permitted by applicable law.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>2. How we use your information</h2>
          <p>We use the information we collect for various purposes, including to:</p>
          <ul>
            <li>Provide, maintain, and improve the Services.</li>
            <li>Personalize your experience with the Services.</li>
            <li>Analyze usage patterns and user interactions to enhance the Services' effectiveness.</li>
            <li>Communicate with you, respond to your inquiries, and provide support.</li>
            <li>Prevent fraud, illegal activity, or misuse of the Services, and to protect the security of our system.</li>
            <li>Develop and train future AI models using the data collected and synthetic data derived from it.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Disclosure of your Information</h2>
          <p>We do not sell or share your information with third parties, except in the following circumstances:</p>
          <ul>
            <li><strong>Service Providers:</strong> We may share information with third-party service providers who perform services on our behalf, such as data storage and processing, provided they agree to adhere to our privacy standards.</li>
            <li><strong>Legal Requirements:</strong> We may disclose your information if required to do so by law, or in response to valid requests by public authorities (e.g., a court or a government agency).</li>
            <li><strong>Protection of Rights:</strong> We may disclose your information to protect the rights, property, or safety of the Company, our users, or others.</li>
            <li><strong>Business Transfers:</strong> If we are involved in strategic transactions, reorganization, bankruptcy, receivership, or transition of service to another provider (collectively, a "Transaction"), your information may be disclosed in the diligence process with counterparties and others assisting with the Transaction and transferred to a successor or affiliate as part of that Transaction along with other assets.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Retention of your information</h2>
          <p>We'll retain your information for only as long as needed to provide the Service to you, or for other legitimate business purposes such as resolving disputes, safety and security, or complying with our legal obligations. How long we retain Personal Data will depend on a number of factors, such as:</p>
          <ul>
            <li>How you are using the Service, and which parts, of the Service you are using, in order to provide the Service to you.</li>
            <li>The amount, nature, and sensitivity of the information.</li>
            <li>Any legal requirements that we are subject to.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>5. Your rights</h2>
          <p>Anyone who uses the Services can access, correct, or delete their personal information regardless of where they live or are physically located, and can opt-out of receiving communications from us by following the unsubscribe instructions provided in the emails or contacting us directly. In addition, under certain data protection laws, individuals may have rights around their personal information which may include (as applicable):</p>
          <ul>
            <li>The right of access to the personal information we have collected and to receive a copy of this personal data.</li>
            <li>The right to correct any incorrect personal information we have collected.</li>
            <li>The right to delete personal information we have retained, subject to specific exceptions.</li>
            <li>The right to limit the use and disclosure of certain sensitive personal information.</li>
            <li>We will process your request in accordance with applicable laws. If you wish to exercise any of the above rights, please <a href='mailto:info@newtherapy.ai'>Contact Us.</a></li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>6. Third-Party links</h2>
          <p>The Services may contain links to third-party websites or services that are not owned or controlled by us. We have no control over, and assume no responsibility for, privacy policies or practices of any third-party websites or services.</p>
        </section>

        <section className="policy-section">
          <h2>7. Children's privacy</h2>
          <p>Our Service is not intended for anyone under the age of 13 ("Children"). We do not knowingly collect personally identifiable information from Children under 13.</p>
        </section>

        <section className="policy-section">
          <h2>8. International data transfers</h2>
          <p>Your information, including Personal Information, may be transferred to — and maintained on — computers located outside of your state, province, country, or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.</p>
        </section>

        <section className="policy-section">
          <h2>9. Changes to this Privacy Policy</h2>
          <p>Company reserves the right to modify this Privacy Policy at any time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
        </section>

        <section className="policy-section">
          <h2>10. Ownership of data</h2>
          <p>Company retains ownership of all data collected through your interactions with the Service as set forth in our <a href='#'>Terms of Use</a>.</p>
        </section>

        <section className="policy-section">
          <h2>11. Data security</h2>
          <p>We implement appropriate technical and organizational measures to protect your data against unauthorized access, loss, misuse, or alteration. However, no method of transmission over the internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your data, we cannot guarantee its absolute security.</p>
        </section>

      </div>
      <Footer />
    </div>
  );
}

export default Privacy; 